export const ADD_OPERATION = 'ADD_OPERATION'
export const REPLACE_OPERATION = 'REPLACE_OPERATION'
export const CLEAR_OPERATIONS = 'CLEAR_OPERATIONS'
export const ADD_CONTRACT = 'ADD_CONTRACT'
export const CLEAR_CONTRACTS = 'CLEAR_CONTRACT'
export const ADD_PRODUCT_TO_CONTRACT = 'ADD_PRODUCT_TO_CONTRACT'
export const CLEAR_PRODUCTS = 'CLEAR_PRODUCT'
export const ADD_PRODUCT_TO_OPERATION = 'ADD_PRODUCT_TO_OPERATION'
export const EDIT_PRODUCT_FROM_MISSION = 'EDIT_PRODUCT_FROM_MISSION'
export const REMOVE_PRODUCT_FROM_OPERATION = 'REMOVE_PRODUCT_FROM_OPERATION'



// WEBPACK FOOTER //
// ./src/common/store/Transactions/types.js